export default "__VITE_ASSET__Dj_g2Sog__"